import { render, staticRenderFns } from "./CustomerInternalNotes.vue?vue&type=template&id=e41a5130&lang=pug&"
import script from "./CustomerInternalNotes.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomerInternalNotes.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CustomerInternalNotes.vue?vue&type=style&index=0&id=e41a5130&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports